/**
 * 拣选策略 Service 层 - 业务逻辑层 + Mock 适配
 * 页面组件只调用此 Service 层，不直接调用 API
 * 对应后端 PickingStrategyConfigController（/api/v1/picking-strategy/...）
 */

import { config } from '../../config';
import * as pickingStrategyMock from '../../mocks/picking-strategy';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';
import type { ApiResponse, PageData } from '../../types/common';
import type {
  PickingStrategyConfigDTO,
  SavePickingStrategyConfigRequest,
} from '../../types/picking-strategy/pickingStrategy';

/**
 * 获取当前登录门店的拣选策略配置（后端根据登录上下文自动获取门店）
 */
export async function getPickingStrategyConfig(): Promise<ApiResponse<PickingStrategyConfigDTO>> {
  if (config.mock) {
    return pickingStrategyMock.mockGetPickingStrategyConfig('default');
  }

  return httpClient.get(API_ENDPOINTS.PICKING_STRATEGY.CONFIG_BASE);
}

/**
 * 统一保存拣选策略配置（称重上下限 + 任务完成时限 + 排序策略）
 */
export async function savePickingStrategyConfig(
  data: SavePickingStrategyConfigRequest
): Promise<ApiResponse<null>> {
  if (config.mock) {
    return { success: true, data: null, flag: 'success', traceId: '' } as ApiResponse<null>;
  }

  return httpClient.post(API_ENDPOINTS.PICKING_STRATEGY.CONFIG_SAVE, data);
}

